var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnpin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11 5.607l10.31 10.29c-.137.268-.323.516-.556.728-.801.733-2.013.747-2.83.06l-.132-.12-3.289-3.27-5.516 5.517-.08.068c-.251.18-.603.158-.829-.068-.226-.226-.248-.578-.068-.83l.068-.079 5.517-5.516-3.295-3.34c-.795-.807-.8-2.1-.013-2.914.211-.218.453-.394.713-.526zM2.264 1.5c.215 0 .395.075.538.226l15.3 15.278c.143.157.214.34.214.548 0 .209-.071.386-.215.53-.15.15-.331.225-.543.225-.212 0-.39-.076-.534-.226L1.715 2.803c-.143-.144-.215-.323-.215-.539 0-.215.072-.395.215-.538.15-.15.334-.226.549-.226zM12.25 0c.62 0 1.186.225 1.623.6l.14.13 4.256 4.255c.45.45.73 1.074.73 1.763 0 1.378-1.117 2.494-2.494 2.494-.466 0-.901-.127-1.269-.345l-.153-.1-.345.415-.96 2.063-6.049-6.04 2.33-1.023.197-.222-.108-.155c-.248-.387-.392-.848-.392-1.341C9.757 1.117 10.874 0 12.251 0z",
    transform: "translate(-295.000000, -56.000000) translate(295.000000, 56.000000) translate(2.499998, 2.500000)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default __webpack_public_path__ + "static/media/unpin.effe93c5.svg";
export { ForwardRef as ReactComponent };